import HomeDropzoneIcon from 'components/atoms/SVG/HomeDropZone';
import {
  DropzoneUI,
  FilesListFooter,
  FilesListHeader,
} from 'components/pages/Expenses/fileUploader.content';
import { createExpenseDocument } from 'components/pages/Expenses/helpers';
import useUpdateSidebarDocCounts from 'hooks/useUpdateSidebarDocCounts';
import { type FC } from 'react';
import { SidebarDocCountsKeysEnum } from 'store/sidebarState';
import type { HomeExpenseUploaderProps } from 'types/expense.types';
import { World } from 'types/shared/worlds';
import { getTracingEvents } from 'utils/amplitude';
import { WEBAPP_EXPENSESLIST_DROPZONEUPLOADING } from 'utils/amplitude/events/expenses.amplitude';
import { expensesMonthlyLimitLockContent } from '../PaywallLockV2/locks.content';
import { SubscriptionCounterKeysEnum } from 'types/subscriptions.types';
import useFeatureLock from 'hooks/Subscriptions/useFeatureLock';
import ExpensesFileUploader from 'components/pages/Expenses/ExpensesFileUploader.component';

const tracingEvents = getTracingEvents({
  onUpload: {
    name: WEBAPP_EXPENSESLIST_DROPZONEUPLOADING,
    data: (fileType: string) => ({ fileType }),
  },
});

const HomeExpenseUploader: FC<HomeExpenseUploaderProps> = ({
  onUpload,
  onClickReviewLater,
  onClickReviewNow,
  renderUploadedFileItem,
  hideDropzoneWhileUploading,
  renderFooter,
  renderHeader,
}) => {
  const updateSidebarCounts = useUpdateSidebarDocCounts();

  const { withPaywallCounterLock } = useFeatureLock();

  return (
    <ExpensesFileUploader
      keepUploadingAfterDestroy
      color="taxes"
      className="flex-col lg:flex-row h-screen"
      onUpload={(api) => {
        tracingEvents.onUpload(api.fileShortType);
        return createExpenseDocument(
          api.file,
          api.onProgress,
          api.options,
        ).then((createdeExpense) => {
          onUpload?.(createdeExpense);

          updateSidebarCounts(SidebarDocCountsKeysEnum.NewExpensesCount);

          return createdeExpense._id;
        });
      }}
      onAfterDropAccepted={(processFiles) =>
        withPaywallCounterLock(
          processFiles,
          SubscriptionCounterKeysEnum.monthlyExpenses,
          expensesMonthlyLimitLockContent,
        )
      }
      filesListContainerClassName="!px-0"
      dropzoneProps={{
        className: 'flex-none lg:flex-1',
        render: (dropzoneMeta, fileUploaderMeta, processFile) => (
          <DropzoneUI
            color={World.TAXES}
            icon={<HomeDropzoneIcon />}
            dropzoneMeta={dropzoneMeta}
            fileUploaderMeta={fileUploaderMeta}
            processFile={processFile}
            imgProps={{ className: '!w-[180px] !h-[180px]' }}
            titleClassNames="!text-base lg:!text-lg"
            hideFakeReceipt
          />
        ),
      }}
      filesListProps={{
        renderFooter:
          renderFooter ||
          ((fileUploaderMeta) => (
            <FilesListFooter
              fileUploaderMeta={fileUploaderMeta}
              onReviewLater={onClickReviewLater}
              onReviewNow={onClickReviewNow}
            />
          )),
        renderHeader:
          renderHeader ||
          ((fileUploaderMeta) => (
            <FilesListHeader fileUploaderMeta={fileUploaderMeta} />
          )),
      }}
      renderUploadedFileItem={renderUploadedFileItem}
      hideDropzoneWhileUploading={hideDropzoneWhileUploading}
    />
  );
};

export default HomeExpenseUploader;
